import React from "react";
import '../../../static/fonts/SegoeUI/fontSegoeUI.css';
import '../../../static/fonts/Intro/fontIntro.css';
import './LayoutInvest.css';
import InvestHeader from "./InvestHeader/InvestHeader";
import InvestFooter from "./InvestFooter/InvestFooter";
const PRERENDER_TEXTS = require("../../../../prerender_base.js");

function LayoutInvest(props) {
    return (
        <div className="LayoutInvest ">
            <InvestHeader  lang={props.lang} PrerenderTexts={PRERENDER_TEXTS["InvestHeader"]} />
            {props.children}
            <InvestFooter  lang={props.lang} PrerenderTexts={PRERENDER_TEXTS["InvestHeader"]}/>

        </div>
    )}

export default LayoutInvest